import { render, staticRenderFns } from "./SimpleGrid.vue?vue&type=template&id=455d8008"
import script from "./SimpleGrid.vue?vue&type=script&lang=js"
export * from "./SimpleGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports